import type { BigSource } from 'big.js';
import type { AmountObject } from '../../../utils/notional.types';

export interface SizeValue extends Omit<AmountObject, 'value'> {
  value: BigSource;
  increment?: string;
  aggregate?: boolean;
}

export const EMPTY_SIZE_VALUE: SizeValue = { value: '', currency: '', increment: undefined };
